import React from 'react';
import { Header, Text, Stack } from '@lessonnine/design-system.lib';
import { ImageContainer } from './index.styled';

export default ({ title, subtitle, Image }) => {
  return (
    <Stack
      className="HeaderComponent"
      alignItems="center"
      gap={ 16 }
      padding={[0, 0, 24, 0]}
    >
      { Image
        && (<ImageContainer className="Header-image"><Image /></ImageContainer>)
      }
      {title && (<Header.h2>{title}</Header.h2>)}
      {subtitle && (<Text>{subtitle}</Text>)}
    </Stack>
  );
};
